import { IValidationPortabilityMobile } from '@vfit/consumer/data-access';
import * as yup from 'yup';

export const portabilityDataSchema = (validationMessage: IValidationPortabilityMobile) =>
  yup.object({
    operator: yup.string().required(validationMessage?.operator?.required || ''),
    contract: yup.string().required(validationMessage?.contract?.required || ''),
    transferBalance: yup.boolean()
  });
